module.exports = __webpack_public_path__ + "fonts/SuisseIntlBold.bf8242e.ttf";